import { memo } from 'react';
import {
    TableRow,
    TableCell,
    TextField,
    Typography,
    IconButton,
    Button,
    Switch,
    Tooltip,
    Stack,
} from '@mui/material';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

const UserRow = memo(({
    user,
    isEditing,
    formData,
    handleInputChange,
    startEdit,
    cancelEdit,
    saveEdit,
    handleStatus,
}) => {
    const isActive = user.status === 'ACTIVO';

    return (
        <TableRow hover>
            <TableCell>
                {isEditing ? (
                    <TextField
                        size="small"
                        name="document"
                        value={formData.document ?? ''}
                        onChange={handleInputChange}
                        variant="standard"
                        fullWidth
                    />
                ) : (
                    user.document || '—'
                )}
            </TableCell>

            <TableCell>{user.type_user_name || '—'}</TableCell>

            <TableCell>
                {isEditing ? (
                    <TextField
                        size="small"
                        name="name"
                        value={formData.name ?? ''}
                        onChange={handleInputChange}
                        variant="standard"
                        fullWidth
                    />
                ) : (
                    user.name || '—'
                )}
            </TableCell>

            <TableCell>
                {isEditing ? (
                    <TextField
                        size="small"
                        name="phone"
                        value={formData.phone ?? ''}
                        onChange={handleInputChange}
                        variant="standard"
                        fullWidth
                    />
                ) : (
                    user.phone || '—'
                )}
            </TableCell>

            <TableCell>
                {isEditing ? (
                    <TextField
                        size="small"
                        name="email"
                        value={formData.email ?? ''}
                        onChange={handleInputChange}
                        variant="standard"
                        fullWidth
                    />
                ) : (
                    user.email || '—'
                )}
            </TableCell>

            <TableCell>
                {isEditing ? (
                    <TextField
                        type="date"
                        size="small"
                        name="date_birth"
                        value={formData.date_birth ?? ''}
                        onChange={handleInputChange}
                        variant="standard"
                        fullWidth
                    />
                ) : (
                    user.date_birth || '—'
                )}
            </TableCell>

            <TableCell>
                {isEditing ? (
                    <TextField
                        size="small"
                        name="gender"
                        value={formData.gender ?? ''}
                        onChange={handleInputChange}
                        variant="standard"
                        fullWidth
                    />
                ) : (
                    user.gender || '—'
                )}
            </TableCell>

            <TableCell>{user.name_city || '—'}</TableCell>

            <TableCell>{user.office_name || '—'}</TableCell>

            <TableCell>
                <Typography
                    color={isActive ? 'success.main' : 'error.main'}
                    fontWeight="medium"
                >
                    {user.status}
                </Typography>
            </TableCell>

            <TableCell align="center">
                {isEditing ? (
                    <Stack direction="row" spacing={1} justifyContent="center">
                        <Tooltip title="Guardar">
                            <IconButton color="primary" onClick={saveEdit} size="small">
                                <SaveOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Cancelar">
                            <IconButton color="error" onClick={cancelEdit} size="small">
                                <CloseOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<ModeEditIcon />}
                        onClick={() => startEdit(user)}
                    >
                        Editar
                    </Button>
                )}
            </TableCell>

            <TableCell align="center">
                <Tooltip title={isActive ? "Desactivar usuario" : "Activar usuario"}>
                    <Switch
                        size="small"
                        checked={user.status === 'ACTIVO'}
                        onChange={() => handleStatus(user.id_user, user.status)}
                        color={user.status === 'ACTIVO' ? 'success' : 'error'}
                        sx={{
                            '& .MuiSwitch-switchBase': {
                                color: '#ff0000',
                            },
                            '& .MuiSwitch-track': {
                                backgroundColor: '#ff0000',
                                opacity: 0.5,
                            },
                            '& .MuiSwitch-switchBase.Mui-checked': {
                                color: '#4caf50',
                                '& + .MuiSwitch-track': {
                                    backgroundColor: '#4caf50',
                                    opacity: 0.7,
                                },
                            },
                        }}
                    />
                </Tooltip>
            </TableCell>
        </TableRow>
    );
});

export default UserRow;